// actions.js
import * as actionTypes from "./actionsTypes";

export const setValueDocs = (value) => ({
  type: actionTypes.SET_VALUE_DOCS,
  payload: value,
});

export const setCategorieDocs = (categorie) => ({
  type: actionTypes.SET_CATEGORIE_DOCS,
  payload: categorie,
});

export const setTypeDocs = (type) => ({
  type: actionTypes.SET_TYPE_DOCS,
  payload: type,
});

export const setCurrentPageDocs = (page) => ({
  type: actionTypes.SET_CURRENT_PAGE_DOCS,
  payload: page,
});

export const setOrderDocs = (order) => ({
  type: actionTypes.SET_ORDER_DOCS,
  payload: order,
});

export const setSortFieldDocs = (field) => ({
  type: actionTypes.SET_SORT_FIELD_DOCS,
  payload: field,
});
